import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import QueryManager from './Query';

const GET_SHOPPER_NOTIFICATIONS = gql`
    query getShopperNotifications($size: Int $page: Int $filters: ShopperNotificationFilter) {
        getShopperNotifications(size: $size page: $page filters: $filters) {
            internalCode
            totalRecords
            totalPage
            payload {
                id_notification
                name
                title
                description
                send_date
                destiny
                shipping
                saleschannels
                creation_date
                update_date
                status
                user_creation
                store_kind
                required_reading
                redirection
            }
        }
    }
`;

const GetShopperNotifications = ({ children, ...props }) => {
    return (
        <QueryManager query={GET_SHOPPER_NOTIFICATIONS} {...props}>
            {({ data, loading, refetch, networkStatus }) => {
                return children({
                    data,
                    refetch,
                    loading,
                    networkStatus
                });
            }}
        </QueryManager>
    );
};

GetShopperNotifications.propTypes = {
    children: PropTypes.any
};

export default GetShopperNotifications;
